import { Account } from "sharedGuiSmall/sharedModels/account";

declare let SendJSError: any;

export class NavigationSmallUtils {

    protected static productCode = '4714343';
    protected static alternativeProductCode = '32316946';

    public static currencies = new Map<string, string>([["GBP", "£"], ["USD", "$"], ["CAD", "$"], ["AUD", "$"], ["EUR", "€"]]);

    public static getCompanyIdForBuyLink(account: Account, caller: string): string {
        let result: string | null = localStorage.getItem('selectedCompanyId');

        if (result === null) {
            console.log(`Buy link companyId is null! - ${caller} for customerRef:${account.customerRef}/${account.externalCustomerRef}, userName:${account.UserName}`);
            SendJSError(
                "Buy link companyId is null!",
                `${caller} for customerRef:${account.customerRef}/${account.externalCustomerRef}, userName:${account.UserName}`,
                '',
                0,
                0,
                '',
                null
            );
        }

        return result === null ? '0' : result;
    }

    public static openPaymentPage(
        account: Account,
        packageType: string,
        frequencyType: string,
        currencyCode: string,
        returnLink: string,
        isAlternativePrice: boolean,
        productVersion: string,
        subscriptionRef: string = ''
    ): void {

        let link = account.pathToBrixxForecast;
        let pCode = isAlternativePrice ? NavigationSmallUtils.alternativeProductCode : NavigationSmallUtils.productCode;

        let selectedCompanyId = NavigationSmallUtils.getCompanyIdForBuyLink(account, 'openPaymentPage()');
        link = link.replace('CompanyID', selectedCompanyId);

        link = link
            .replace('#{license}', subscriptionRef)
            .replace('package', packageType)
            .replace('frequency', frequencyType)
            .replace('cur', currencyCode)
            .replace('dcur', currencyCode)
            .replace("EMAIL=", "EMAIL=" + account.UserName)
            .replace('productCode', pCode)
            .replace('productVersion', productVersion)
            .replace('optCode', 'OPTIONS' + pCode);

        if (account.externalCustomerRef != '')
            link = link + "&CUSTOMERID=" + account.externalCustomerRef.toString();
        else if (account.customerRef != 0)
            link = link + "&AV_CUSTOMERID=" + account.customerRef.toString();

        link = link + "&REF=" + returnLink;

        window.open(link, '_self');

    }
}
